(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bj-email-capture"] && !Shopify.designMode) return;
  try {
    
  // Posts the email straight to a Klaviyo list via the client subscriptions API. No libraries.
  (function () {
    function init(form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var company = form.getAttribute('data-klaviyo-company');
        var listId = form.getAttribute('data-klaviyo-list');
        var input = form.querySelector('input[type="email"]');
        var msg = form.querySelector('.bj-email__msg');
        var btn = form.querySelector('button[type="submit"]');
        var email = (input.value || '').trim();
        if (!email || !input.checkValidity()) { msg.style.color = '#ff8a8a'; msg.textContent = 'Enter a valid email.'; return; }
        if (!company || !listId) { msg.style.color = '#ff8a8a'; msg.textContent = 'Signup is not configured yet.'; return; }
        btn.disabled = true; msg.style.color = ''; msg.textContent = '…';
        var payload = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: listId } } } } };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (r.ok || r.status === 202) {
            var row = form.querySelector('.bj-email__row'); if (row) row.style.display = 'none';
            msg.style.color = ''; msg.textContent = form.getAttribute('data-success') || 'Done. keep an eye on your inbox.';
          } else { throw new Error('status ' + r.status); }
        }).catch(function () {
          btn.disabled = false; msg.style.color = '#ff8a8a'; msg.textContent = 'Something went wrong. please try again.';
        });
      });
    }
    document.querySelectorAll('.bj-email-form').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-engraving-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bj-ehero video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      if (!('IntersectionObserver' in window)) { var p0 = v.play(); if (p0 && p0.catch) p0.catch(function () {}); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.2 }).observe(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-fd-arrive"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bj-arrive]').forEach(function (card) {
      var zones;
      try { zones = JSON.parse(card.getAttribute('data-zones')); } catch (e) { return; }
      var cutoff = parseInt(card.getAttribute('data-cutoff'), 10) || 13;
      var evParts = (card.getAttribute('data-event') || '').split('-');
      var eve = null;
      if (evParts.length === 3) {
        eve = new Date(parseInt(evParts[0], 10), parseInt(evParts[1], 10) - 1, parseInt(evParts[2], 10) - 1, 23, 59);
      }
      var input = card.querySelector('[data-bj-arr-input]');
      var go = card.querySelector('[data-bj-arr-go]');
      var res = card.querySelector('[data-bj-arr-res]');

      function zoneFor(pc) {
        var n = parseInt(pc, 10);
        if (isNaN(n)) return null;
        for (var i = 0; i < zones.length; i++) {
          if (n >= zones[i][0] && n <= zones[i][1]) return { s: zones[i][2], e: zones[i][3] };
        }
        return null;
      }
      function aestNow() {
        var d = new Date();
        return new Date(d.getTime() + (600 + d.getTimezoneOffset()) * 60000);
      }
      function dispatchDay() {
        var d = aestNow();
        if (d.getHours() >= cutoff || d.getDay() === 0 || d.getDay() === 6) {
          do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
        }
        return d;
      }
      function addBiz(from, days) {
        var d = new Date(from);
        while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
        return d;
      }
      function fmt(d) {
        var wd = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return wd[d.getDay()] + ' ' + d.getDate() + ' ' + mo[d.getMonth()];
      }
      function verdict(el, d) {
        if (!eve) { el.textContent = ''; return; }
        var ok = d <= eve;
        el.textContent = ok ? "✓ before Father's Day" : "after Father's Day";
        el.classList.toggle('is-ok', ok);
        el.classList.toggle('is-no', !ok);
      }
      function run() {
        var z = zoneFor(input.value.trim());
        if (!z) { res.classList.remove('is-on'); return; }
        var ship = dispatchDay();
        var sd = addBiz(ship, z.s);
        var ed = addBiz(ship, z.e);
        card.querySelector('[data-bj-arr-std]').textContent = 'by ' + fmt(sd);
        card.querySelector('[data-bj-arr-exp]').textContent = 'by ' + fmt(ed);
        verdict(card.querySelector('[data-bj-arr-stdv]'), sd);
        verdict(card.querySelector('[data-bj-arr-expv]'), ed);
        res.classList.add('is-on');
        try { localStorage.setItem('bj_postcode', input.value.trim()); } catch (err) {}
      }
      go.addEventListener('click', run);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      try {
        var saved = localStorage.getItem('bj_postcode');
        if (saved && saved.length >= 3) { input.value = saved; }
      } catch (err) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-fd-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bj-fd-days]').forEach(function (el) {
      var parts = (el.getAttribute('data-date') || '').split('-');
      if (parts.length !== 3) return;
      var target = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      var days = Math.ceil((target - new Date()) / 86400000);
      var label = el.getAttribute('data-label') || 'days to go';
      if (days > 1) el.textContent = days + ' ' + label;
      else if (days === 1) el.textContent = '1 day to go';
      else if (days === 0) el.textContent = "It's today";
      else el.textContent = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-fd-orderby"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bj-countdown]').forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 13;
      function targetUtc(dateStr) {
        var p = (dateStr || '').split('-');
        if (p.length !== 3) return null;
        return Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10), hour - 10, 0, 0);
      }
      var stdT = targetUtc(el.getAttribute('data-std'));
      var expT = targetUtc(el.getAttribute('data-exp'));
      var label = el.querySelector('[data-bj-cd-label]');
      var clock = el.querySelector('[data-bj-cd-clock]');
      var dEl = el.querySelector('[data-bj-cd-d]');
      var hEl = el.querySelector('[data-bj-cd-h]');
      var mEl = el.querySelector('[data-bj-cd-m]');
      var sEl = el.querySelector('[data-bj-cd-s]');
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var now = Date.now();
        var target = null;
        if (stdT && now < stdT) {
          target = stdT;
          label.textContent = el.getAttribute('data-label-std');
        } else if (expT && now < expT) {
          target = expT;
          label.textContent = el.getAttribute('data-label-exp');
        } else {
          label.textContent = el.getAttribute('data-closed');
          clock.style.display = 'none';
          return;
        }
        var left = Math.max(0, Math.floor((target - now) / 1000));
        dEl.textContent = Math.floor(left / 86400);
        hEl.textContent = pad(Math.floor(left % 86400 / 3600));
        mEl.textContent = pad(Math.floor(left % 3600 / 60));
        sEl.textContent = pad(left % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-footer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('form[data-bj-news]').forEach(function (form) {
    var msg = form.querySelector('[data-bj-news-msg]');
    var input = form.querySelector('input[name="email"]');
    var key = form.getAttribute('data-key');
    var list = form.getAttribute('data-list');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') < 1) { msg.textContent = 'Enter a valid email.'; msg.className = 'bj-ft__msg bj-ft__msg--err'; return; }
      msg.textContent = 'Just a sec...'; msg.className = 'bj-ft__msg';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
      }).then(function (r) {
        if (r.ok || r.status === 202) { msg.textContent = 'Check your inbox for your code.'; msg.className = 'bj-ft__msg bj-ft__msg--ok'; form.reset(); }
        else { msg.textContent = 'Something went wrong. Try again.'; msg.className = 'bj-ft__msg bj-ft__msg--err'; }
      }).catch(function () { msg.textContent = 'Something went wrong. Try again.'; msg.className = 'bj-ft__msg bj-ft__msg--err'; });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-idea-bank"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bj-idea-chips').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.bj-chip');
        if (!chip || chip.classList.contains('is-copied')) return;
        var text = chip.getAttribute('data-copy') || chip.textContent.trim();
        if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text); }
        var orig = chip.textContent;
        chip.classList.add('is-copied');
        chip.textContent = 'Copied ✓';
        setTimeout(function () { chip.textContent = orig; chip.classList.remove('is-copied'); }, 1100);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-paper-method-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ---- generic open/close for paper-method modals only ----
    function initModal(modal) {
      var id = modal.id; if (!id) return;
      var lastFocus = null;
      function focusables() { return modal.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'); }
      function open(opener) { lastFocus = opener || document.activeElement; modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; var f=focusables(); if(f.length) f[0].focus(); document.addEventListener('keydown',onKey); }
      function close() { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; document.removeEventListener('keydown',onKey); if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
      function onKey(e){ if(e.key==='Escape'){close();return;} if(e.key==='Tab'){ var f=focusables(); if(!f.length)return; var first=f[0],last=f[f.length-1]; if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();} else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();} } }
      document.addEventListener('click', function(e){
        var opener=e.target.closest('[data-bj-modal-open="'+id+'"]');
        if(opener){ e.preventDefault(); open(opener); return; }
        if(modal.contains(e.target)&&e.target.closest('[data-bj-modal-close]')){ e.preventDefault(); close(); return; }
        if(e.target===modal){ close(); }
      });
    }
    document.querySelectorAll('.bj-modal[data-bj-paper]').forEach(initModal);

    // ---- circumference → Billie Jo size calculator ----
    var CIRC = [[46.8,4],[49.3,5],[51.9,6],[54.4,7],[57.0,8],[59.5,9],[62.1,10],[64.6,11],[67.2,12],[69.7,13],[72.3,14],[74.8,15]];
    function nearest(v){ var b=CIRC[0],bd=1e9; for(var i=0;i<CIRC.length;i++){ var d=Math.abs(CIRC[i][0]-v); if(d<bd){bd=d;b=CIRC[i];} } return {us:b[1],diff:bd}; }
    document.querySelectorAll('.bj-pcalc').forEach(function(calc){
      var input=calc.querySelector('.bj-pcalc__input'), btn=calc.querySelector('.bj-pcalc__go'), out=calc.querySelector('.bj-pcalc__result');
      function go(){
        var n=parseFloat((String(input.value).match(/-?\d+(\.\d+)?/)||[])[0]);
        if(isNaN(n)){ out.innerHTML='<div class="bj-pcalc__err">Pop in the length you measured, in mm.</div>'; return; }
        var r=nearest(n);
        var warn = r.diff>1.2 ? '<div class="bj-pcalc__warn">You\'re between sizes. we rounded to the nearest. Want a snug fit? Size up.</div>' : '';
        out.innerHTML='<div class="bj-pcalc__out"><div class="bj-pcalc__cap">Your Billie Jo size</div><div class="bj-pcalc__size">'+r.us+'</div></div>'+warn;
      }
      btn.addEventListener('click',go);
      input.addEventListener('keydown',function(e){ if(e.key==='Enter') go(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-review-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bj-rc]').forEach(function (sec) {
    var track = sec.querySelector('.bj-rc__track');
    var prev = sec.querySelector('.bj-rc__arrow--prev');
    var next = sec.querySelector('.bj-rc__arrow--next');
    if (!track || !prev || !next) return;
    function step() {
      var card = track.querySelector('.bj-rc__card');
      return card ? card.getBoundingClientRect().width + 12 : 280;
    }
    function update() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-ring-converter"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (document.getElementById('bjmode') && document.getElementById('bjmode').dataset.bjInit) return;
  var modeEl = document.getElementById('bjmode'); if (!modeEl) return;
  modeEl.dataset.bjInit = '1';
  var TABLE = [
    {us:4,  au:"I",   eu:47, diam:14.9, circ:46.8},
    {us:5,  au:"K½",  eu:49, diam:15.7, circ:49.3},
    {us:6,  au:"M",   eu:52, diam:16.5, circ:51.9},
    {us:7,  au:"N½",  eu:54, diam:17.3, circ:54.4},
    {us:8,  au:"P½",  eu:57, diam:18.1, circ:57.0},
    {us:9,  au:"R½",  eu:60, diam:18.9, circ:59.5},
    {us:10, au:"T½",  eu:62, diam:19.8, circ:62.1},
    {us:11, au:"V½",  eu:65, diam:20.6, circ:64.6},
    {us:12, au:"X½",  eu:67, diam:21.4, circ:67.2},
    {us:13, au:"Z",   eu:70, diam:22.2, circ:69.7},
    {us:14, au:"Z+2", eu:72, diam:23.0, circ:72.3},
    {us:15, au:"Z+4", eu:74, diam:23.8, circ:74.8}
  ];
  var AU_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  var PLACEHOLDER = { circ:"e.g. 54", diam:"e.g. 17.3", us:"e.g. 7", au:"e.g. N or N½", eu:"e.g. 54" };

  function nearest(key,val){ var best=TABLE[0],bd=1e9; for(var i=0;i<TABLE.length;i++){var d=Math.abs(TABLE[i][key]-val); if(d<bd){bd=d;best=TABLE[i];}} return {row:best,diff:bd}; }
  function rowByAU(letter,half){ var idx=AU_LETTERS.indexOf(letter); if(idx<0) return null; var circ=37.8+idx*1.25+(half?0.62:0); return nearest('circ',circ).row; }

  function render(row,note,warn){
    var el=document.getElementById('bjresult');
    if(!row){ el.innerHTML='<div class="bj-err">Hmm, couldn\'t read that. Check the option above matches what you\'re entering and try again.</div>'; return; }
    var g='';
    g+='<div><div class="cap">AU / UK</div><div class="val">'+row.au+'</div></div>';
    g+='<div><div class="cap">EU</div><div class="val">'+row.eu+'</div></div>';
    g+='<div><div class="cap">Diameter</div><div class="val">'+row.diam.toFixed(1)+'mm</div></div>';
    g+='<div><div class="cap">Circumf.</div><div class="val">'+row.circ.toFixed(1)+'mm</div></div>';
    el.innerHTML='<div class="bj-out">'+
      '<div class="bj-out-top"><div class="bj-out-cap">Your Billie Jo size</div><div class="bj-out-size">'+row.us+'</div></div>'+
      '<div class="bj-out-grid">'+g+'</div>'+
      (note?'<p class="bj-out-note">'+note+'</p>':'')+
      '</div>'+(warn?'<div class="bj-warn">'+warn+'</div>':'');
  }

  function convert(){
    var mode=document.getElementById('bjmode').value;
    var raw=document.getElementById('bjinput').value.trim().toLowerCase();
    if(!raw){ render(null); return; }
    if(mode==='au'){
      var m=raw.match(/([a-z])\s*(½|1\/2|\.5)?/);
      if(!m){ render(null); return; }
      var zp=raw.match(/z\s*\+\s*(\d)/);
      if(zp){ var zr=TABLE.filter(function(r){return r.au==="Z+"+zp[1];})[0]; render(zr||null, zr?"From AU/UK size Z+"+zp[1]:null); return; }
      var r=rowByAU(m[1].toUpperCase(), !!m[2]);
      render(r, r?"From AU/UK size "+m[1].toUpperCase()+(m[2]?"½":""):null);
      return;
    }
    var num=parseFloat((raw.match(/-?\d+(\.\d+)?/)||[])[0]);
    if(isNaN(num)){ render(null); return; }
    if(mode==='us'){ var ru=nearest('us',num); render(ru.row,(num<4||num>15)?"That's outside our 4-15 range. showing the closest.":"From US size "+num); return; }
    if(mode==='eu'){ render(nearest('eu',num).row,"From EU size "+num); return; }
    if(mode==='circ'){ var rc=nearest('circ',num); render(rc.row,"From "+num+"mm around your finger", rc.diff>1.2?"You're between sizes. we rounded to the nearest. After a snug fit? Size up.":null); return; }
    if(mode==='diam'){ var rd=nearest('diam',num); render(rd.row,"From "+num+"mm across the ring", rd.diff>0.4?"You're between sizes. we rounded to the nearest. Want it snug? Size up.":null); return; }
  }

  var input=document.getElementById('bjinput'), modeSel=document.getElementById('bjmode');
  function setPlaceholder(){ input.placeholder=PLACEHOLDER[modeSel.value]; }
  setPlaceholder();
  modeSel.addEventListener('change',function(){ setPlaceholder(); input.value=''; document.getElementById('bjresult').innerHTML=''; input.focus(); });
  document.getElementById('bjgo').addEventListener('click',convert);
  input.addEventListener('keydown',function(e){ if(e.key==='Enter') convert(); });

  var tb=document.getElementById('bjtbody'), rows='';
  for(var i=0;i<TABLE.length;i++){ var t=TABLE[i]; var pop=(t.us===7||t.us===10)?' class="pop"':''; rows+='<tr'+pop+'><td>'+t.diam.toFixed(1)+'</td><td>'+t.circ.toFixed(1)+'</td><td>'+t.us+'</td><td>'+t.au+'</td></tr>'; }
  tb.innerHTML=rows;

  var modal=document.getElementById('bjmodal');
  function open(){ modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); }
  function close(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); }
  var link=document.getElementById('bjchartlink'); if(link) link.addEventListener('click',open);
  modal.querySelectorAll('[data-close]').forEach(function(b){ b.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-sizer-proof"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bj-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var cover = wrap.querySelector('[data-bj-play]');
      if (!video || !cover) return;
      var label = cover.querySelector('[data-bj-coverlabel]');
      var labelText = label ? label.textContent : '';
      var againText = wrap.getAttribute('data-again') || 'Play again';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      cover.addEventListener('click', function () {
        if (video.ended) video.currentTime = 0;
        if (label) label.textContent = labelText;
        cover.classList.add('is-hidden');
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      });
      video.addEventListener('play', function () { cover.classList.add('is-hidden'); });
      video.addEventListener('ended', function () {
        if (label) label.textContent = againText;
        cover.classList.remove('is-hidden');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bj-sticky-sizer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-bj-sticky]');
    if (!bar) return;
    var btn = bar.querySelector('[data-bj-sticky-btn]');
    var hero = document.querySelector('.bj-hero__sizer');
    function onScroll() {
      var show = window.scrollY > 560;
      if (hero) {
        var r = hero.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) show = false; // hero sizer visible
      }
      bar.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
    if (btn) btn.addEventListener('click', function () {
      var sizer = document.querySelector('.bj-hero__sizer');
      if (!sizer) return;
      var target = sizer.querySelector('button') || sizer.querySelector('.aitaca-black-button') || sizer.querySelector('aitaca-widget') || sizer;
      try { target.click(); } catch (e) {}
      setTimeout(function () {
        if (!document.querySelector('.aitaca-modal, [class*="aitaca"][class*="open"], [class*="aitaca"][class*="modal"]')) {
          sizer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 400);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
